<template>
    <div>
        <Header title="历史订单">
        </Header>
        
        <div class="my-white-mod">
            <div style="margin-bottom:10px">
                <Input prefix="ios-search" v-model="search_name" placeholder="姓名、单号、订单编号" style="width:200px;"></Input>
                <Select  style="width:165px;margin-left:10px" placeholder="请选择销售人员"  v-model="search_sale_id" clearable  filterable >
                    <Option v-for="(item, index) in department_member_list" :value="item.id" :key="index">{{item.platform_name}}-{{ item.name }}</Option>
                </Select>
                <Select  style="width:165px;margin-left:10px" placeholder="请选择售后人员"  v-model="search_aftersale_id" clearable  filterable >
                    <Option v-for="(item, index) in department_member_list" :value="item.id" :key="'l'+index ">{{item.platform_name}}-{{ item.name }}</Option>
                </Select>
                <TagScreen @changeTags="changeTag" @changeTagsId="changeTagId"></TagScreen>
            </div>
            <div>
                <DatePicker type="daterange" placement="bottom-end" placeholder="选择成交时间" style="width: 200px"  @on-change="change_success_date"></DatePicker>
                <DatePicker type="daterange" placement="bottom-end" placeholder="选择交付时间" style="width: 200px;margin-left:10px"  @on-change="change_date"></DatePicker>
            
                <Button  @click="searchList" type="warning" style="margin-left:10px">搜索</Button>
                <Button   v-if="userInfo.role == 0 "  @click="ok_export" type="success" style="margin-left:10px">导出</Button>
            </div>
        </div>
        <div class="my-white-mod">

            <PageTable  :loading="table.loading"  :size="table.limit" :columns="table.columns" :data="table.data" :current="table.current" :total="table.total" @switchPage="changepage"  >
            </PageTable>
        </div>

        <Modal
                v-model="show_tree"
                title="选择对接方式"
                width="800"
                :mask-closable="false"
        >
            <div v-if="submitForm.docking_list.length > 0" style="display: flex;flex-flow:row wrap ">
                <div v-for="(item, index) in submitForm.docking_list" :key="index" style="margin:5px 0; padding:0 10px; border-right:1px solid #dddddd" >
                    {{ item.name }} ￥{{ item.money }}
                </div>
            </div>
            <Tree :data="dock_data" show-checkbox ref="tree" @on-select-change="changeTreeSelect" @on-check-change="changeTreeCheck" ></Tree>
        </Modal>

        <Modal
                v-model="show_follow"
                title="跟进记录"
                width="1000"
                :mask-closable="false"
        >

            <PageTable  :loading="follow_table.loading" :size="follow_table.limit" :columns="follow_table.columns" :data="follow_table.data" :current="follow_table.current" :total="follow_table.total" @switchPage="change_record"  >
            </PageTable>
            <div slot="footer"></div>
        </Modal>

        <Modal
                v-model="show_history"
                title="售后记录"
                width="700"
                :mask-closable="false"
        >
            <PageTable  :loading="history_table.loading" :size="history_table.limit" :columns="history_table.columns" :data="history_table.data" :current="history_table.current" :total="history_table.total" @switchPage="change_history"  >
            </PageTable>
            <div slot="footer"></div>
        </Modal>
        <DealShow ref="deal_child" :show_success.sync="show_success" :order_id="order_id" :customer_name="customer_name" :department_member_list="department_member_list"  :successSubmit="successSubmit" @submitSuccess="orderSubmitSuccess"></DealShow>
        
        <!-- <Modal
                v-model="show_success"
                title="修改"
                :mask-closable="false"
                width="650"
        >

            <Divider>当前单号：{{order_id}} / 客户名称：{{customer_name}}</Divider>
            <Form :model="successSubmit" :rules="ruleValidate" inline :label-width="80" >

                <FormItem label="成交时间" prop="pay_time">
                    <DatePicker style="width:187px" :options="options3"  type="datetime" v-model="successSubmit.pay_time" placeholder="选择成交时间" @on-change="changeSuccessDate"></DatePicker>
                </FormItem>
                <FormItem label="成交方式" prop="transaction_type_id">
                    <Select style="width:187px" placeholder="请选择成交方式" v-model="successSubmit.transaction_type_id" filterable >
                        <Option v-for="item in transaction_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="完整单号" prop="order_number">
                    <Input  style="width:165px"   placeholder="请填写完整订单号" v-model="successSubmit.order_number"  >
                    </Input>
                </FormItem>
                <FormItem label="已收金额" prop="money">
                    <Input  placeholder="请填写已收金额"    v-model="successSubmit.money"  >
                    </Input>
                </FormItem>
                <FormItem label="尾款" prop="retainage">
                    <Input   placeholder="如没有，可以不填写" v-model="successSubmit.retainage"  >
                    </Input>
                </FormItem>
                <FormItem label="企微群" prop="qq_group">
                    <Input  placeholder="请填写所在群" type="text" v-model="successSubmit.qq_group" />
                </FormItem>
                <FormItem label="服务费" prop="servicecharge">
                    <Input  style="width:165px"   placeholder="请填写服务费" v-model="successSubmit.servicecharge"  >
                    </Input>
                    <Tooltip content="作为下次收款的依据">
                        <Icon style="margin-left:3px;cursor:pointer" size="20" type="ios-help-circle-outline" />
                    </Tooltip>
                </FormItem>
                <FormItem label="售后人员" prop="aftersale_id">
                    <Select  style="width:165px" placeholder="请选择售后人员"  v-model="successSubmit.aftersale_id" clearable  filterable >
                        <Option v-for="(item, index) in department_member_list" :value="item.id" :key="index">{{item.platform_name}}-{{ item.name }}</Option>
                    </Select>
                    <Tooltip >
                        <div slot="content">
                            <p>不选择售后则默认为不需要售后</p>
                            <p>订单将直接进入完结状态</p>
                        </div>
                        <Icon style="margin-left:3px;cursor:pointer" size="20" type="ios-help-circle-outline" />
                    </Tooltip>
                </FormItem>
                <span v-show="!successSubmit.aftersale_id ">
                    <FormItem label="到期类型" prop="duesoon_type">
                        <Select style="width:187px" placeholder="请选择到期类型" v-model="successSubmit.duesoon_type" filterable >
                            <Option value="1" >选择到期时间</Option>
                            <Option value="2" >永久有效</Option>
                        </Select>
                    </FormItem>
                </span>
                <span v-show="!successSubmit.aftersale_id && successSubmit.duesoon_type == 1">
                    <FormItem label="到期时间" prop="expiration_date">
                        <DatePicker style="width:187px"  v-model="successSubmit.expiration_date"  type="date" placeholder="选择日期" @on-change="changeDate"></DatePicker>
                    </FormItem>
                </span>
                <FormItem label="服务要求" prop="service_requirements">
                    <Input style="width:460px"  placeholder="请填写服务要求：系统类型 公众认证情况 是否需要申请支付功能" type="textarea" v-model="successSubmit.service_requirements" />
                </FormItem>
                <Divider>客户信息</Divider>
                <FormItem label="姓名" prop="name">
                    <Input  placeholder="请填写姓名" v-model="successSubmit.name"  >
                    </Input>
                </FormItem>
                <FormItem label="备注名称" prop="remark">
                    <Input  placeholder="请填写备注名称" v-model="successSubmit.remark"  >
                    </Input>
                </FormItem>
                <FormItem label="手机号" prop="phone">
                    <Input  placeholder="请填写手机号" v-model="successSubmit.phone"  >
                    </Input>
                </FormItem>
                <FormItem label="微信昵称" prop="wechat_number">
                    <Input  placeholder="请填写微信昵称" v-model="successSubmit.wechat_number"  >
                    </Input>
                </FormItem>
                <FormItem label="旺旺号" prop="wangwang_number">
                    <Input  placeholder="请填写旺旺号" v-model="successSubmit.wangwang_number"  >
                    </Input>
                </FormItem>
                <FormItem label="选择城市" prop="city_number">
                    <CitySelect @select_city="success_city" :default_citys="successSubmit.city_number"></CitySelect>
                </FormItem>
                <FormItem label="详细地址" prop="detailed_address">
                    <Input style="width:460px" placeholder="请填写详细地址" v-model="successSubmit.detailed_address"  >
                    </Input>
                </FormItem>
            </form>

            <div slot="footer">
                <Button  type="primary"  @click="success_order">确定</Button >
            </div>
        </Modal> -->

        <Modal
                v-model="show_refund"
                title="退款记录"
                width="800"
                :mask-closable="false"
        >
            <Button  style="margin-bottom:10px" @click="add_refund_fun" >申请退款</Button>
            <PageTable  :loading="refund_table.loading" :size="refund_table.limit" :columns="refund_table.columns" :data="refund_table.data" :current="refund_table.current" :total="refund_table.total" @switchPage="change_refund"  >
            </PageTable>
            <div slot="footer"></div>
        </Modal>
        <Modal
                v-model="show_add_refund"
                title="退款"
                :mask-closable="false"
                width="400"
        >
            <Input placeholder="请输入退款金额" v-model="formRefund.money" type="text"  />

            <Input placeholder="请输入退款原因" v-model="formRefund.apply_desc" type="textarea" style="margin-top:5px" />
            <div slot="footer">
                <Button  type="primary"  @click="edit_refund">确定</Button >
            </div>
        </Modal>

        
        <Modal
                v-model="show_dock"
                title="交付"
                width="500"
                :mask-closable="false"
        >
            <div>当前单号：{{submitForm.id}}</div>
            <div>客户名称：{{submitForm.customer_name}}</div>
            <div>服务要求：{{submitForm.service_requirements}}</div>
            <div class="modal-title modal-title-two">客户类型</div>
            <Select filterable v-model="submitForm.customer_type_id">
                <Option v-for="item in customer_type_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
            
            
            <div class="modal-title modal-title-two">对接类型  <Icon style="margin-left:5px;cursor: pointer" size="18" @click="loadCascade" type="md-refresh" /></div>
            <Button  type="dashed" @click="showTreeModal" >￥{{submitForm.docking_money }}</Button>
            <div v-if="submitForm.docking_list.length > 0" style="display: flex;flex-flow:row wrap ">
                <div v-for="(item, index) in submitForm.docking_list" :key="index" style="margin:5px 0; padding:0 10px; border-right:1px solid #dddddd" >
                    {{ item.name }} ￥{{ item.money }}
                </div>
            </div>
            <div class="modal-title modal-title-two">到期类型</div>
            <RadioGroup v-model="submitForm.duesoon_type">
                <Radio label="1" border>选择到期时间</Radio>
                <Radio label="2" border>永久有效</Radio>
            </RadioGroup>
            <span v-if=" submitForm.duesoon_type == 1">
                <div class="modal-title modal-title-two">到期时间</div>
                <DatePicker type="date" placeholder="选择日期" v-model="submitForm.expiration_date" style="width: 200px" @on-change="changeDuesDate"></DatePicker>
            </span>


            <div class="modal-title modal-title-two">客户资料</div>
            <Input  placeholder="客户资料" type="textarea"  v-model="submitForm.information" />
            <div class="modal-title modal-title-two">平台名称</div>
            <Input  placeholder="请填写平台名称"   v-model="submitForm.platform_name" />
            <div class="modal-title modal-title-two">登录地址</div>
            <Input  placeholder="请填写登录地址"   v-model="submitForm.login_url" />
            <div class="modal-title modal-title-two">账户</div>
            <Input  placeholder="请填写账户"   v-model="submitForm.account" />
            <div class="modal-title modal-title-two">密码</div>
            <Input  placeholder="请填写密码"   v-model="submitForm.pwd" />
            <div slot="footer">
                <Button  type="primary"  @click="deliver_order">确定</Button >
            </div>
        </Modal>
        <Tags :customer_id="customer_id" :show_tags="show_label" :tags_active="tags_active" :is_return="tags_return" @return_data="get_select_tags" @hide_lable="hide_label_func"></Tags>
    </div>

</template>
<script>
    import { customer_type, follow_record_list, customer_department_member,get_transaction } from "@/api/customer"
    import { get_dock_cascade_list } from  "@/api/system"
    import {order_history, after_history, order_edit, order_refund, order_refund_list, delete_refund_order, export_history_list, order_deliver} from "@/api/order"
    import {Header, PageTable, TagScreen, CitySelect,Tags,DealShow } from "@/components/mainLayout"
    import {copyText} from "@/utils/helper";
    import moment from "moment"
export default {
    components:{
        Header,
        PageTable,
        TagScreen,
        Tags,
        CitySelect,
        DealShow
    },
    data(){
        return{
            show_label:false,
            tags_return:false,
            show_tree:false,
            dock_data: [],
            customer_type_list:[],
            screen_tags_text:"",
            screen_tags_id:"",
            show_add_refund:false,
            show_refund:false,
            tags_active:[],
            customer_name:"",
            customer_loading:false,
            department_member_list:[],
            show_infos:false,
            customer_id:"",
            order_id:0,
            show_history:false,
            order_delivery_status:0,
            show_follow:false,
            show_success:false,
            formRefund:{
                moeny:0,
                order_id:0,
                apply_desc:""
            },
            show_dock:false,
            submitForm:{
                docking_name:"",
                docking_money:0,
                docking_list:[]
            },
            options3: {
                disabledDate (date) {
                    return date && date.valueOf() > Date.now();
                }
            },
            search_name:"",
            search_sale_id:"",
            search_aftersale_id:"",
            ruleValidate:{
                money: [
                    { required: true, message: '请填写已付金额', trigger: 'blur' }
                ],
                qq_group: [
                    { required: true, message: '请填写企微群号', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请填写姓名', trigger: 'blur' }
                ],
                wechat_number: [
                    { required: true, message: '请填写微信号', trigger: 'blur' }
                ],

                servicecharge: [
                    { required: true, message: '请填写服务费', trigger: 'blur' }
                ],
                transaction_type_id: [
                    { required: true, message: '请填写成交方式', trigger: 'blur' }
                ],
                service_requirements: [
                    { required: true, message: '请填写服务要求', trigger: 'blur' }
                ]

            },
            transaction_list:[],
            successSubmit:{
                order_product_id:[],
                duesoon_type:'1',
                money:"",
                transaction_type_id:"",
                aftersale_id:"",
                service_requirements:"",
                servicecharge:"",
                qq_group:"",
                retainage:"",
                order_number:"",
                name:"",
                phone:"",
                wechat_number:"",
                wangwang_number:"",
                city_number:[],
                city_name:"",
                detailed_address:"",
                pay_time:"",
                remark:"",
                latlng: "",
                is_big: "0",
            },
            follow_table: {
                loading:false,
                current: 1,
                total: 0,
                limit: 30,
                columns: [
                    {
                        type:'index',
                        width:'80',
                        align:'center'
                    },{
                        title: '跟进时间',
                        align:'center',
                        width:'180',
                        key: 'follow_time'
                    },{
                        title: '状态',
                        align:'center',
                        key: 'id',
                        render: (h, params) => {
                            let status_name = params.row.follow_type == 1 ? "首次跟进" : `第`+params.row.follow_type+`次跟进`;
                            return h('div', [
                                h('span', {}, status_name)
                            ]);

                        }
                    },{
                        title: '图片',
                        align:'center',
                        key: 'ctime',
                        render: (h, params) => {
                            let img_arr = [];
                            for (let i in params.row.follow_img) {
                                img_arr.push(params.row.follow_img[i].url)
                            }
                            if(img_arr.length > 0){
                                return h('div', img_arr.map(img=>{ //循环显示
                                        return h('img',  {
                                            attrs: {
                                                src: img,
                                                style: 'width: 30px;height: 30px;cursor:pointer'
                                            },
                                            on:{
                                                click:()=>{
                                                    let content = '<img src="'+img+'" style="width:100%;height:100%" />';
                                                    this.$Modal.info({
                                                        title: "预览",
                                                        content: content
                                                    });
                                                }
                                            }
                                        },);
                                    })
                                )
                            }else{
                                return h("span", '');
                            }

                        }
                    },{
                        title: '备注',
                        align:'center',
                        key: 'note',
                        width:'200',
                        render: (h, params) => {
                            return h('Input',{
                                props: {
                                    value:params.row.note,
                                    type:'textarea'
                                }
                            })
                        }
                    },{
                        title: '负责人员',
                        align:'center',
                        key: 'responsible_name'
                    }],
                data:[]
            },
            refund_table: {
                loading:false,
                current: 1,
                total: 0,
                limit: 30,
                columns: [
                    {
                        type:'index',
                        width:'80',
                        align:'center'
                    },{
                        title: '申请时间',
                        align:'center',
                        width:'170',
                        key: 'ctime',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style:{color:'#445E87'}
                                }, params.row.ctime.replace("T", " "))
                            ]);
                        }
                    },{
                        title: '状态',
                        align:'center',
                        width:'100',
                        key: 'ctime',
                        render: (h, params) => {
                            let text = params.row.refund_status == 0 ? "待审核" : params.row.refund_status == 1 ? "已通过" :"被拒绝"
                            let color = params.row.refund_status == 0 ? "#445E87" : params.row.refund_status == 1 ? "#4caf50" :"#ff0000"
                            return h('div', [
                                h('span', {
                                    style:{color:color}
                                }, text)
                            ]);
                        }
                    },{
                        title: '申请金额',
                        align:'center',
                        width:'120',
                        key: 'money'
                    },{
                        title: '申请原因',
                        align:'center',
                        width:'120',
                        key: 'apply_desc'
                    },{
                        title: '退款金额',
                        align:'center',
                        width:'120',
                        key: 'refund_money'
                    },{
                        title: '审核时间',
                        align:'center',
                        width:'170',
                        key: 'refund_time',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style:{color:'#445E87'}
                                }, params.row.refund_time ? params.row.refund_time.replace("T", " ") : "")
                            ]);
                        }
                    },{
                        title: '拒绝原因',
                        align:'center',
                        width:'170',
                        key: 'reason',
                        render: (h, params) => {
                            return h('Input',{
                                props: {
                                    value:params.row.reason,
                                    type:'textarea'
                                }
                            })
                        }
                    },{
                        title: '操作',
                        align:'center',
                        key: 'id',
                        fixed: 'right',
                        width:80,
                        render: (h, params) => {
                            let btnArr = []

                            let deleteBtn = h('span', {
                                style:{color:'#ff0000',cursor:'pointer'},
                                on: {
                                    click: () => {
                                        this.delete_refund_order(params.row.id)
                                    }
                                }
                            }, '删除')

                            if (params.row.refund_status == 0) {
                                btnArr.push(deleteBtn)
                            }

                            return h('div', btnArr);

                        }

                    }],
                data:[]
            },
            history_table: {
                loading:false,
                current: 1,
                total: 0,
                limit: 30,
                columns: [
                    {
                        type:'index',
                        width:'80',
                        align:'center'
                    },{
                        title: '操作时间',
                        align:'center',
                        width:'180',
                        key: 'ctime',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style:{color:'#445E87'}
                                }, params.row.ctime.replace("T", " "))
                            ]);
                        }
                    },{
                        title: '操作',
                        align:'center',
                        key: 'id',
                        render: (h, params) => {
                            let status_name = params.row.status == 1 ? "交付" : params.row.status == 2 ? "对接": params.row.status == 3 ? "挂起":"进度";
                            return h('div', [
                                h('span', {}, status_name)
                            ]);

                        }
                    },{
                        title: '备注',
                        align:'center',
                        key: 'reason',
                        width:'200',
                        render: (h, params) => {
                            return h('Input',{
                                props: {
                                    value:params.row.reason,
                                    type:'textarea'
                                }
                            })
                        }
                    },{
                        title: '负责人员',
                        align:'center',
                        key: 'reason',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, params.row.department_member_name ? params.row.department_member_name : "admin")
                            ]);
                        }
                    }],
                data:[]
            },
            table:{
                loading:false,
                current:1,
                total:0,
                limit:30,
                columns: [
                    {
                        title: '单号',
                        width:'110',
                        align:'center',
                        key: 'id',
                        render: (h, params) => {
                            let retainage_text = params.row.most_retainage_id ? "<span style='color:red'>尾款主单"+params.row.most_retainage_id+"</span>" :""
                            let text = params.row.is_examine == 1?"<span style='color:red'>已审核</span>" :"";
                            let delivery_text = params.row.delivery_status == 0?"<span style='color:red'>未交付</span>" :params.row.delivery_status == 9?"<span style='color:#000'>停止对接</span>" :"";
                            return h("div", {
                                domProps:{
                                    innerHTML:`<div >`+params.row.id +`</div><div >`+ delivery_text  +`</div><div >`+ text  +`</div><div >`+ retainage_text  +`</div>`
                                }
                            })

                        }
                    },
                    {
                        title: '订单编号',
                        width:'100',
                        align:'center',
                        key: 'order_number'
                    },
                    {
                        title: '客户',
                        align:'center',
                        key: 'name',
                        width:260,
                        render: (h, params) => {
                            let male = require("../../assets/11.png");
                            let female = require("../../assets/12.png");
                            let default_img = require("../../assets/3.png");
                            if (params.row.avatar != null && params.row.avatar != "") {
                                default_img = params.row.avatar
                            }
                            let default_ = female;
                            if (params.row.gender == 1) {
                                default_ = male;
                            }
                            if (params.row.is_big == 1) {
                                var default_big = require("@/assets/is_big.png");
                            }
                            return h("div", {
                                domProps:{
                                    innerHTML:`<div style="text-align: left;padding-bottom:5px;cursor:pointer"><div style="display: flex;padding:10px 0 5px;height: 70px">`+
                                        `<img src=`+default_img+` style="width:50px;height:50px;">` +
                                        `<div style="margin-left:10px;flex:1;text-align: left;">` +
                                            `<div>`+(params.row.remark || params.row.customer_name)+`</div>`+
                                            `<div><img src=`+default_+` style="width:20px;height:20px;"><img src=`+default_big+` style="width:32px;height:10.5px;">`+`</div>`+
                                        `</div>` +
                                        `</div>`+
                                        `企微群：`+ (params.row.qq_group ? params.row.qq_group :"无")+
                                        `</div>`
                                },
                                on:{
                                    click:()=>{
                                        copyText(params.row.remark || params.row.customer_name)
                                    }
                                }
                            })

                        }
                    },
                    {
                        title: '标签',
                        align:'center',
                        key: 'id',
                        width:200,
                        render: (h, params) => {
                            let tpl = "", tag_name = params.row.tag_name;
                            if (tag_name && tag_name.length > 0) {
                                for(let i in tag_name) {
                                    tpl += `<div><div  class="tag-class">`+tag_name[i]+`</div></div>`;
                                }
                            } else {
                                tpl += `<div class="tag-dotted">尚未设置</div>`;
                            }
                            return h("div", {
                                domProps:{
                                    innerHTML:`<div style="display:flex;flex-wrap:wrap;padding:10px 0 5px">`+
                                        tpl +
                                        `</div>`
                                },
                                on: {
                                    click: () => {
                                        this.customer_id = params.row.customerId;
                                        this.tags_active = params.row.tags_active;
                                        this.tags_return = false;
                                        this.show_label = true
                                    }
                                }
                            })

                        }
                    },
                    {
                        title: '成交金额',
                        align:'center',
                        width:150,
                        key: 'pay_money',
                            render: (h, params) => {
                                let refund_text = params.row.refund_count_success > 0 ? "<div style='color:#ff0000;font-weight:600' >退款￥"+params.row.refund_money+"</div>":""
                                return h("div", {
                                    domProps:{
                                        innerHTML:`<div >`+params.row.pay_money +`</div>`
                                                +`<div >`+ (params.row.retainage_status == 0 ? "<span style='color:#f90'>尾款￥"+params.row.retainage+"</span>" :"" ) +`</div>`+refund_text
                                    }
                                })

                            }
                    },{
                        title: '成交日期',
                        align:'center',
                        width:180,
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style:{color:'#445E87'}
                                }, params.row.pay_time.replace("T", " "))
                            ]);
                        }
                    },
                    {
                        title: '跟进员工',
                        align:'center',
                        key: 'id',
                        width:150,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                    },
                                    style:{color:'#3F8CFF'},
                                    on: {
                                        click: () => {
                                            this.order_id = params.row.id;
                                            this.show_follow = true;
                                            this.record_list();
                                        }
                                    }
                                }, params.row.department_member_name)
                            ]);

                        }
                    },
                    {
                        title: '售后员工',
                        align:'center',
                        key: 'after_name',
                        width:120,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#3F8CFF'},
                                    on: {
                                        click: () => {
                                            this.order_id = params.row.id
                                            this.order_delivery_status = params.row.delivery_status
                                            this.show_history_list()
                                        }
                                    }
                                }, params.row.after_name)
                            ]);

                        }
                    },
                    {
                        title: '交付时间',
                        align:'center',
                        width:180,
                        key: 'pay_time',
                        render: (h, params) => {

                            return h('div', [
                                h('span', {
                                    style:{color:'#515a6e'}
                                }, params.row.delivery_time ? params.row.delivery_time.replace("T", " "): "")
                            ]);

                        }
                    },
                    {
                        title: '对接时间',
                        align:'center',
                        width:170,
                        key: 'dock_time',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style:{color:'#445E87'}
                                }, params.row.dock_time ? params.row.dock_time.replace("T", " ") : "")
                            ]);
                        }
                    },
                    {
                        title: '到期时间',
                        align:'center',
                        width:120,
                        key: 'pay_time',
                        render: (h, params) => {
                            let text = params.row.duesoon_type == 1 ? params.row.expiration_date : "永久"

                            return h('div', [
                                h('span', {
                                    style:{color:'#515a6e'}
                                }, text)
                            ]);

                        }
                    },
                    {
                        title: '添加时间',
                        align:'center',
                        width:180,
                        key: 'ctime'
                    }
                    ,{
                        title: '操作',
                        align:'center',
                        key: 'id',
                        fixed: 'right',
                        width:140,
                        render: (h, params) => {
                            let btnArr = []
                            let lookbtn = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                style:{color:'#3F8CFF'},
                                on: {
                                    click: () => {
                                        this.$router.push({
                                            path: '/customerpool/info',
                                            query: {
                                                order_id: params.row.id,
                                                customer_id:params.row.customerId,
                                                type:6
                                            }
                                        });
                                    }
                                }
                            }, '详情')
                            let editbtn = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                style:{color:'#ff0000'},
                                on: {
                                    click: () => {
                                        this.order_id = params.row.id;
                                        this.customer_name = (params.row.remark && params.row.remark !=  null ) ? params.row.remark : params.row.customer_name ;
                                        this.show_success = true;
                                        let after_id = 0;
                                        for (let i in this.department_member_list) {
                                            if (this.department_member_list[i].wx_uid == params.row.aftersale_id && this.department_member_list[i].platform_id == params.row.aftersale_platform) {
                                                after_id = this.department_member_list[i].id
                                            }
                                        }
                                        this.successSubmit = {
                                            id:this.order_id,
                                            order_product_id:params.row.order_product_id ? (params.row.order_product_id.length > 0 ? params.row.order_product_id.map(Number) : []):[],
                                            duesoon_type:parseInt(params.row.duesoon_type),
                                            qq_group:params.row.qq_group,
                                            money:params.row.pay_money,
                                            pay_time:params.row.pay_time,
                                            customer_source_id:params.row.customer_source_id,
                                            order_number:params.row.order_number,
                                            transaction_type_id:parseInt(params.row.transactionTypeId),
                                            aftersale_id:parseInt(after_id),
                                            service_requirements:params.row.service_requirements,
                                            expiration_date:params.row.expiration_date,
                                            servicecharge:params.row.servicecharge,
                                            name:params.row.customer_name,
                                            remark:params.row.remark,
                                            phone:params.row.phone,
                                            wechat_number:params.row.wechat_number,
                                            wangwang_number:params.row.wangwang_number,
                                            city_number:params.row.city_number,
                                            city_name:params.row.city_name,
                                            detailed_address:params.row.detailed_address,
                                            retainage:params.row.retainage,
                                            is_two_sale:params.row.is_two_sale + "",
                                            latlng: params.row.latlng,
                                            is_big: params.row.is_big + "",
                                        }
                                    }
                                }
                            }, '修改')
                            
                            let deliverBtn = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                style:{color:'#3F8CFF'},
                                on: {
                                    click: () => {
                                        this.submitForm = {
                                            docking_list: params.row.docking_list ? JSON.parse(params.row.docking_list) : [],
                                            docking_name:params.row.docking_name,
                                            docking_money:params.row.docking_money || 0 ,
                                            duesoon_type:params.row.duesoon_type.toString(),
                                            expiration_date:params.row.expiration_date,
                                            id:params.row.id,
                                            information:params.row.information,
                                            customer_type_id:params.row.customer_type_id,
                                            platform_name:params.row.platform_name,
                                            account:params.row.account,
                                            login_url:params.row.login_url,
                                            pwd:params.row.pwd,
                                            customer_name:params.row.remark ? params.row.remark : params.row.customer_name,
                                            service_requirements:params.row.service_requirements,
                                            status:1
                                        }
                                        console.log(this.submitForm)
                                        this.show_dock = true;
                                    }
                                }
                            }, '重新交付')
                            let refundbtn = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                style:{color:'#ff0000'},
                                on: {
                                    click: () => {
                                        this.order_id = params.row.id;
                                        this.show_refund = true;
                                        this.refund_list()
                                    }
                                }
                            }, '退款');
                            
                            btnArr.push(lookbtn)
                            // && (this.userInfo.role == 2 || this.userInfo.role == 5 || this.userInfo.role == 6 || this.userInfo.role == 0)
                            if (( params.row.is_examine != 1 && this.$store.state.userInfo.user_id == params.row.department_member_id) || this.$store.state.userInfo.user_id == 0) {
                                btnArr.push(editbtn)
                            }
                            if ( (params.row.is_examine != 1 && this.$store.state.userInfo.user_id == params.row.aftersale_id)  || this.$store.state.userInfo.user_id == 0){
                                btnArr.push(deliverBtn)
                            }
                            if(this.$store.state.userInfo.user_id == params.row.department_member_id || this.$store.state.userInfo.user_id == 0  ) {
                                btnArr.push(refundbtn)
                            }
                           
                         

                            return h('div', btnArr);

                        }

                    }
                ],
                data: [],
                default_cid:0,
                search_customer:"",
                commit:0
            },
            userInfo:{},
            start_date:"",
            end_date:"",
            dock_list_new:[],
            success_start_date:"",
            success_end_date:""

        }
    },
    mounted(){
        this.userInfo = this.$store.state.userInfo
        this.getList();
        this.get_customer_type();
        this.get_customer_department_member()
        this.get_transaction_list()
        this.loadCascade()
    },
    methods:{
        showTreeModal(){
            this.show_tree = true
        },
        loadCascade(){
            get_dock_cascade_list().then(res=>{
                if(res.code == 200) {
                    this.dock_data = res.data
                    this.dock_list_new =  JSON.parse(JSON.stringify(res.data)) 
                    this.$Message.success(res.msg);
                } else {
                    this.dock_list_new =  this.dock_data = []
                    this.$Message.error(res.msg);
                }
            })
        },
        changeTreeCheck(v){
            let docking_list = v.filter(r=> (r.children.length == 0))
            this.submitForm.docking_money = 0;
            this.submitForm.docking_name = [];
            this.submitForm.docking_list = []
            
            docking_list.forEach( res => {
                this.submitForm.docking_list.push({'name':res.title, 'money':res.money, 'value':res.value})
                this.submitForm.docking_money += res.money
                this.submitForm.docking_name.push(res.title)
            })
            this.submitForm.docking_name = this.submitForm.docking_name.join(",")
        },
        changeTreeSelect(e, v){
            if (v.children.length > 0) {
                v.expand = v.expand ? false : true
                return
            }
        },

        changeDuesDate(e){
            this.submitForm.expiration_date = e;
        },
        deliver_order(){
            
            if (this.submitForm.docking_list.length == 0) {
                    this.$Message.error("请选择对接方式");return;
            }
          
            if (this.submitForm.duesoon_type == '1' && (this.submitForm.expiration_date == "" || this.submitForm.expiration_date == undefined)) {
                this.$Message.error("请选择到期时间");return;
            }
            this.dock_data = JSON.parse(JSON.stringify(this.dock_list_new));
                console.log(this.dock_data)
            order_deliver(this.submitForm).then(res=>{
                if(res.code == 200) {
                    this.$Message.success(res.msg)
                    this.getList();
                    this.show_dock = false;
                } else {
                    this.$Message.error(res.msg)
                }
            })
        },
        
        get_customer_type(){
            customer_type().then(res=>{
                this.customer_type_list = res.data;
            })
        },
        change_date(e){
            this.start_date = e[0]
            this.end_date = e[1]
        },
        change_success_date(e){
            this.success_start_date = e[0]
            this.success_end_date = e[1]
        },
        ok_export(){
            if (this.commit == 1) {
                return
            }
            let val = {};
            if(this.search_name != "") {
                val.search_name = this.search_name
            }
            if(this.search_sale_id != "") {
                val.search_sale_id = this.search_sale_id
            }
            if(this.search_aftersale_id != "") {
                val.search_aftersale_id = this.search_aftersale_id
            }
            // if (this.screen_tags_text != "")  {
            //     val.screen_tags_text = this.screen_tags_text
            // }
            if (this.screen_tags_id != "")  {
                val.screen_tags_id = this.screen_tags_id
            }
            
            if(this.start_date != "") {
                val.start_date = this.start_date
            }
            if(this.end_date != "") {
                val.end_date = this.end_date
            }
            if(this.success_start_date != "") {
                val.success_start_date = this.success_start_date
            }
            if(this.success_end_date != "") {
                val.success_end_date = this.success_end_date
            }
            this.$Message.info({
                content: '处理数据中，请等待',
                duration: 0
            });
            this.commit = 1;
            let _this = this
            export_history_list(val).then(res=>{
                setTimeout(function(){
                    _this.commit = 0;
                }, 500)
                this.$Message.destroy()
                if(res.code == 200) {
                    let url = res.data
                    if (navigator.userAgent.indexOf("Safari") > -1) {
                        const newPage = window.open("newPage", "_blank");
                        newPage.location = url;
                    } else {
                        window.open(url, "_blank").location;
                    }
                } else {
                    this.$Message.error(res.msg);
                }
            }).catch(err=>{
                setTimeout(function(){
                    _this.commit = 0;
                }, 500)
            })
        },
        closeWindowEvent() {
            if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
                window.opener = null;
                window.open("", "_self", "");
                window.location.href = "about:blank";
                window.close();
            } else {
                window.opener = null;
                window.open("", "_self", "");
                window.location.href = "about:blank";
                window.close();
            }
        },
        success_city(e){
            this.successSubmit.city_name = e.city_name
            this.successSubmit.city_number = e.city_number
        },
        select_city(e){
            this.submitInfo.city_name = e.city_name
            this.submitInfo.city_number = e.city_number
        },
        searchList(){
            this.table.current = 1
            this.getList()
        },
        show_history_list(){
            this.show_history = true
            this.history_list()
        },
        history_list(){
            this.history_table.loading = true;
            after_history({limit:this.history_table.limit, page:this.history_table.current, order_id:this.order_id}).then(res=>{
                this.history_table.loading = false;
                if(res.code == 200) {
                    this.history_table.data = res.data;
                    this.history_table.total = res.total;
                } else {
                    this.history_table.data = [];
                    this.history_table.total = 0;
                    this.$Message.error(res.msg)
                }
            })
        },

        // 操作记录换页
        change_history(e){
            this.history_table.current = e;
            this.history_list();
        },

        getList(){
            let val = {limit:this.table.limit, page:this.table.current};
            if(this.search_name != "") {
                val.search_name = this.search_name
            }
            if(this.search_sale_id != "") {
                val.search_sale_id = this.search_sale_id
            }
            if(this.search_aftersale_id != "") {
                val.search_aftersale_id = this.search_aftersale_id
            }
            // if (this.screen_tags_text != "")  {
            //     val.screen_tags_text = this.screen_tags_text
            // }
            if (this.screen_tags_id != "")  {
                val.screen_tags_id = this.screen_tags_id
            }
            
            if(this.start_date != "") {
                val.start_date = this.start_date
            }
            if(this.end_date != "") {
                val.end_date = this.end_date
            }
            if(this.success_start_date != "") {
                val.success_start_date = this.success_start_date
            }
            if(this.success_end_date != "") {
                val.success_end_date = this.success_end_date
            }
            this.table.loading = true;
            order_history(val).then(res=>{
                this.table.loading = false;
                if(res.code == 200) {
                    this.table.data = res.data;
                    this.table.total = res.total;
                } else {
                    this.table.data = [];
                    this.table.total = 0;
                    this.$Message.error(res.msg);
                }
            })
        },

        changeTag(e){
            this.screen_tags_text = e;
        },
        changeTagId(e){
            this.screen_tags_id = e;
        },
        changepage(e){
            this.table.current = e;
            this.getList();
        },
        // 查询跟进记录
        record_list(){

            this.follow_table.loading = true;
            follow_record_list({order_id:this.order_id, limit:this.follow_table.limit, page:this.follow_table.current}).then(res=>{
                this.follow_table.loading = false;
                if (res.code == 200) {
                    this.follow_table.data = res.data;
                    this.follow_table.total = res.total;
                } else {
                    this.follow_table.data = [];
                    this.follow_table.total = 0;
                    this.$Message.error(res.msg);
                }
            })
        },
        // 跟进记录换页
        change_record(e){
            this.follow_table.current = e;
            this.record_list();
        },


        get_customer_department_member(){
            customer_department_member().then(res=>{
                this.department_member_list = res.data
            })
        },

        changeDate(e){
            this.successSubmit.expiration_date = e;
        },
        changeSuccessDate(e){
            this.successSubmit.pay_time = e;
        },

        get_transaction_list(){
            get_transaction().then(res=>{
                if(res.code == 200) {
                    this.transaction_list = res.data
                }
            })
        },
        // success_order(){

        //     if (this.commit == 1) {
        //         return
        //     }
        //     if ( this.successSubmit.pay_time == "" || this.successSubmit.pay_time == null) {
        //         this.$Message.error("请选择成交时间");return;
        //     }

        //     if(this.successSubmit.aftersale_id == "" && this.successSubmit.duesoon_type == '1' && this.successSubmit.expiration_date == "") {
        //         this.$Message.error("售后人员或者到期时间必须选择一个");return
        //     }
        //     this.successSubmit.id = this.order_id;
        //     this.successSubmit.money = this.successSubmit.money == ""? 0 : this.successSubmit.money;
        //     if ( this.successSubmit.transaction_type_id == "" || this.successSubmit.transaction_type_id == null) {
        //         this.$Message.error("请选择成交方式");return;
        //     }
        //     if ( this.successSubmit.service_requirements == "" || this.successSubmit.service_requirements == null) {
        //         this.$Message.error("请填写服务要求");return;
        //     }
        //     if ( this.successSubmit.qq_group == "" || this.successSubmit.qq_group == null) {
        //         this.$Message.error("请填写所在的企微群");return;
        //     }
        //     if ( this.successSubmit.name == "" || this.successSubmit.name == null) {
        //         this.$Message.error("请填写客户姓名");return;
        //     }

        //     // if ( this.successSubmit.phone == "" || this.successSubmit.phone == null) {
        //     //     this.$Message.error("请填写客户手机号");return;
        //     // }
        //     if ( this.successSubmit.wechat_number == "" || this.successSubmit.wechat_number == null) {
        //         this.$Message.error("请填写客户微信昵称");return;
        //     }

        //     // if ( this.successSubmit.order_number == "" || this.successSubmit.order_number == null) {
        //     //     this.$Message.error("请填写订单编号");return;
        //     // }

        //     if ( this.successSubmit.pay_time == "" || this.successSubmit.pay_time == null) {
        //         this.$Message.error("请选择成交时间");return;
        //     }
        //     // if (this.successSubmit.city_name == null || this.successSubmit.city_name == "" || this.successSubmit.city_number.length == 0) {
        //     //     this.$Message.error("请选择顾客所在城市");return;
        //     // }
        //     this.successSubmit.pay_time = moment(this.successSubmit.pay_time).format('YYYY-MM-DD HH:mm:ss')

        //     this.$Message.info({
        //         content: '提交中，请等待',
        //         duration: 0
        //     });
        //     this.commit = 1;
        //     order_edit(this.successSubmit).then(res=>{
        //         this.commit = 0;
        //         this.$Message.destroy()
        //         if (res.code == 200) {
        //             this.show_success = false;
        //             this.getList();
        //             this.$Message.success(res.msg);
        //             // this.send_notice(res.data)
        //         } else {
        //             this.$Message.error(res.msg);
        //         }
        //     })
        // },
        
        orderSubmitSuccess(){
            this.$Message.info({
                content: '提交中，请等待',
                duration: 0
            });
            order_edit(this.successSubmit).then(res=>{
                this.$Message.destroy()
                if (res.code == 200) {
                    this.show_success = false
                    this.$Message.success(res.msg);
                    this.getList();
                } else {
                    this.$Message.error(res.msg);
                }
                this.$refs.deal_child.is_submit = 0;
            })
        },
        change_refund(e){
            this.refund_table.current = e;
            this.refund_list();
        },

        add_refund_fun(){
            this.formRefund ={
                order_id: this.order_id,
                money:"",
                apply_desc:""
            };
            this.show_add_refund = true;
        },
        delete_refund_order(e){
            this.$Modal.confirm({
                title: '提示',
                content: '<p>确认删除此次申请记录？</p>',
                onOk: () => {
                    delete_refund_order({refund_id:e}).then(res=>{
                        if (res.code == 200) {
                            this.refund_list()
                            this.$Message.success(res.msg);
                        } else {
                            this.$Message.error(res.msg)
                        }
                    })
                }
            });
        },

        refund_list(){
            this.refund_table.loading = true;
            order_refund_list({order_id:this.order_id, limit:this.refund_table.limit, page:this.refund_table.current}).then(res=>{
                this.refund_table.loading = false;
                if (res.code == 200) {
                    this.refund_table.data = res.data;
                    this.refund_table.total = res.total;
                } else {
                    this.refund_table.data = [];
                    this.refund_table.total = 0;
                    this.$Message.error(res.msg);
                }
            })
        },
        edit_refund(){
            if (this.commit == 1) {
                return
            }
            if (this.formRefund.money == "" || this.formRefund.money == 0) {
                this.$Message.error("请输入退款金额");return
            }
            this.$Message.info({
                content: '提交中',
                duration: 0
            });
            this.commit = 1;
            order_refund(this.formRefund).then(res=>{
                this.commit = 0;
                this.$Message.destroy()
                if (res.code == 200) {
                    this.refund_list()
                    this.show_add_refund = false;
                    this.$Message.success(res.msg);
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },
        
        get_select_tags(e){
            this.show_label = false;
            this.screen_tags_list = e;
            this.screen_tags_active = ""
            this.screen_tags_text = ""
            if (this.screen_tags_list) {
                this.tags_active = [];
                let screen_tags = [];
                for(let i in this.screen_tags_list) {
                    this.tags_active.push(this.screen_tags_list[i].tag_id+"，"+this.screen_tags_list[i].tag_name)
                    screen_tags.push(this.screen_tags_list[i].tag_name)
                }
                this.screen_tags_active = this.tags_active
                this.screen_tags_text = screen_tags.join(",")
            }
        },
        hide_label_func(e){
            this.show_label = false
            if (e == 1) {
                this.getList()
            }
        },
    }
}
</script>
<style scoped>

    >>>.tag-class{
        width: 90%;
        padding:5px 10px;
        border:1px solid #ddd;
        border-radius: 5px;
        margin:2px 5px;
        background: #ffffff;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
        cursor: pointer;
    }
    >>>.tag-dotted{

        width: 90%;
        padding:5px 10px;
        border:1px dotted #ddd;
        border-radius: 5px;
        margin:2px 5px;
        cursor: pointer;
    }

    >>> #add_customer .ivu-select-dropdown-list .ivu-select-item{
        height:50px
    }
</style>
